import { OmneoClient } from './classes/client'

export let omneo = null
OmneoClient.init().then((client) => {
  omneo = client
  window.omneo = client
})
